export const getEnumKeyByValue = <T extends Record<string, string>>(enumObj: T, value: string): keyof T | '' =>
  (Object.keys(enumObj) as (keyof T)[]).find((key) => enumObj[key] === value) || ''

export const checkValueInArrayEnum = <T extends Record<string, unknown>, V = unknown>(value: V, arrayEnum: T): boolean =>
  Object.values(arrayEnum).includes(value as T[keyof T])
